export default __webpack_public_path__ + "static/media/cold-water.bd7f3e6f.svg";